var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SiruiSearch',{ref:"baseInfoFormRef",attrs:{"query":_vm.query,"columns":_vm.formColumn,"isQueryPanel":false,"isDisabledForm":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }